import React from 'react';

import { FolderSearch } from 'lucide-react';

const NoData = ({ description = "No data to display" }) => {
  return (
    <div
      className="flex flex-col flex-1 items-center justify-center w-auto h-auto rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 py-12 text-center">
      <FolderSearch className="h-12 w-12 text-gray-400"/>
      
      <p className="mt-4 font-medium text-gray-500">
        {description}
      </p>
    </div>
  );
};

export default NoData;
